import { Classroom } from '@teetsh/app/src/types/classroom';
import { getMutualWorkingDays } from '@teetsh/app/src/containers/utils';
import { getNormalizedDay } from '@teetsh/app/src/containers/printUtils/getNormalizedDay';

export function getNormalizedWorkingDays(classrooms: Classroom[]) {
  const days = getMutualWorkingDays(classrooms);
  return days.map(d => getNormalizedDay(d));
}
